import React, { useState, useMemo } from "react";
import EventListItem from "./EventListItem";
import CrmDropdown from "../../shared/components/CrmDropdown";
import CrmSearchInput from "../../shared/components/CrmSearchInput";

const EventsList = ({ events, selectedEventId, onSelectEvent, sortBy, onSortChange, sortOptions }) => {
  const [search, setSearch] = useState("");

  const filteredEvents = useMemo(() => {
    if (!search.trim()) return events;
    const term = search.toLowerCase();
    return events.filter((e) =>
      (e.title || "").toLowerCase().includes(term) ||
      (e.venueName || "").toLowerCase().includes(term)
    );
  }, [events, search]);

  return (
    <div className="meta-social-ads__events-list">
      <div className="meta-social-ads__events-header">
        <div className="meta-social-ads__events-header-row">
          <span>Events ({filteredEvents.length})</span>
          <CrmDropdown
            value={sortBy}
            options={sortOptions}
            onChange={onSortChange}
            placeholder="Sort"
            enableSearch={false}
            minWidth={140}
            menuAlign="right"
            ariaLabel="Sort events"
            buttonStyle={{ padding: '4px 28px 4px 8px', fontSize: 12, border: 'none', boxShadow: 'none', background: 'transparent' }}
          />
        </div>
      </div>
      <div style={{ padding: '8px 12px 8px' }}>
        <CrmSearchInput
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          placeholder="Search events..."
          shortcutLabel={null}
          useDebounce={false}
        />
      </div>
      {filteredEvents.map((event) => (
        <EventListItem
          key={event.id}
          event={event}
          isSelected={event.id === selectedEventId}
          onSelect={onSelectEvent}
        />
      ))}
    </div>
  );
};

export default EventsList;
